module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('video', {
    ref: "remoteVideo",
    attrs: {
      "autoplay": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f929db4a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Media.vue
// module id = 718
// module chunks = 1